<template lang="pug">

div
  // Header row para desktop
  div.container.d-none.d-md-block
    b-row
      b-col(cols='6').d-flex.justify-content-flex-start.align-items-center
        b-icon.back-arrow.h3.cursor-pointer(
          icon="arrow-left-square-fill"
          variant=""
          @click="$router.go(-1)"
        )
        h4.pl-3.title Oportunidades de Venta
      b-col.tittle-head(cols='6')
        div.pl-2
          b-dropdown(variant="primary")
            template(#button-content)
              span.primary-btn Exportar
              b-icon(icon="box-arrow-in-right")
            b-dropdown-text.export-text Exportar:

            b-dropdown-item(@click="setExportType(null)")
              b-icon(icon ="calendar3").mr-2
              | Rango de Fecha
              b-col(cols='3')
            b-dropdown-item(@click="setExportType('details')")
              b-icon(icon ="calendar3").mr-2
              | Rango de Fecha y con detalle de repuestos
              b-col(cols='3')
        div.pl-2
          b-dropdown(variant="primary", id="register-ov-button")
            template(#button-content)
              span.primary-btn Registrar Nueva
            b-dropdown-item(@click="openModalCotizacionNew", id="new-ov-button")
              | Generar Cotización
              b-col(cols='3')

            GenerarCotizacion()
        div
          OVSearchInput(
            v-model="paramsSearch"
            @search="buscar"
            :loading="loadingTable"
            @clearParamsSearch="paramsSearch = ''; buscar()"
            desktop
          )

  // Header row para mobile
  div.d-flex.d-md-none.flex-column.mb-3
    div.d-flex.align-items-center.mb-2(style="gap: 12px;")
      b-icon.back-arrow.h3.mb-0.cursor-pointer(
        icon="arrow-left-square-fill"
        variant=""
        @click="$router.go(-1)"
      )
      h4.mb-0.font-weight-bold.flex-grow-1 Oportunidades de Venta
    div.d-flex.align-items-center.justify-content-between.mb-2(style="gap: 12px;")
      b-button(
        @click="showBottomSheet.show = true; showBottomSheet.type = bottomSheetTypes.COTIZACION_NEW"
        variant="primary"
      )
        span Registrar Nueva
      b-button(
        @click="showBottomSheet.show = true; showBottomSheet.type = bottomSheetTypes.EXPORT"
        variant="primary"
      )
        span Exportar
    OVSearchInput(
      v-model="paramsSearch"
      @search="buscar"
      :loading="loadingTable"
      @clearParamsSearch="paramsSearch = ''; buscar()"
    )

  b-container
    b-tabs(pills card lazy v-model= "tabSelected"
      @activate-tab="onTabChange"
    )
      b-tab(
        v-for="estado in estados"
        :key="estado.estado"
        :title="`${estado.estado} (${estado.cantidad})`"

      )
    b-row
      b-col
        b-table(
          id="ov-table"
          :items="items"
          :fields="fields"
          hover
          responsive
          :busy="loadingTable"
          @sort-changed="sortingChanged"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          no-local-sorting

        )
          template(#table-busy)
            div.text-center.p-3
              b-spinner(label="Cargando...").mr-2
              span Cargando datos...
          template(#cell(index)="data")
            span {{ data.index + 1 }}
          template(#cell(created_at)="data")
            span {{ data.item.created_at | formatedDate }}
          template(#cell(id)="data")
            span(
              v-if="!data.item.ov_rechazada"
            )
              router-link.text-no-rechazada(
                :to="`/oportunidad-venta/${data.item.id}`"
              ) {{ data.item.id }}
            b-badge.badge-rechazada.badge-rechazada-margin(
              v-if="data.item.ov_rechazada"
              variant="danger"
              v-b-tooltip.hover :title="`Oportunidad creada a partir de la OV rechazada: ${data.item.ov_rechazada}`"
            )
              router-link.text-white(
               :to="`/oportunidad-venta/${data.item.id}`"
              ) {{ data.item.id }}
          template(#cell(rma)="data")
            span {{ data.item.rma || '-'}}
          template(#cell(monto_total_neto)="data")
            span {{ Math.floor(data.item.monto_total_neto * 1.19) | formatCurrency }}
          template(#cell(monto_descuento)="data")
            span(v-if="data.item.porcentaje_descuento") {{ getAmountWithDiscount(data.item) | formatCurrency }}
          template(#cell(ot)="data")
            a(
              v-if="data.item.ot"
              :href="`/orden/${data.item.ot}`"
              target="_blank"
            ) {{ data.item.ot }}
            span(v-else) -
          template(#cell(cotizacion_pdf)="data")
            a(
              :href="informeUrl(data.item.cotizacion_pdf)"
              target="_blank",
              v-if="data.item.cotizacion_pdf"
            ) Descargar Cot-{{data.item.id}}
            p(v-else) -
          template(#cell(acciones)="data")
            OVActionsIndex(:ovId="data.item.id", :dataOv="data.item" )
        div.text-center(v-if="showEmptyData" style="background-color: #fff;").p-4
            img(src="@/assets/no_data_ov.jpg" style="width: 40%; height: 40%; display: block; margin: 0 auto;")
            div
              span No hay registros de la oportunidad de venta
              br
              span Puedes crear una desde el botón que está ahí arriba
              br
              span.text-subtitle “Generar Oportunidad de Venta”.
        b-pagination(
          v-if="totalRows > 0"
          v-model="currentPage",
          :total-rows="totalRows",
          :per-page="pageSize",
          align="right"
          prev-text="Ant.",
          next-text="Sig.",
          @change="handlePageChange"
          aria-controls="ov-table"
        )
    b-modal(v-model="showExportRangeModal" title="Exportar Oportunidades de Venta" hide-footer)
      b-form-group
        label.label-color Desde
        b-form-datepicker(v-model="start_date" placeholder="Por favor selecciona una fecha")
      b-form-group
        label.label-color Hasta
        b-form-datepicker(v-model="end_date" placeholder="Por favor selecciona una fecha")
      div.row
        div.col.p-2.d-flex.flex-row.justify-content-end
          b-button.secondary-btn(
            @click="closeModal()"
            variant="outlined"
          ) Cancelar
          b-button.ml-2.primary-btn(
            @click="exportExcel()"
            variant="samtek-yellow"
            :disabled="!start_date || !end_date || loading"
          )
            b-spinner.ml-4.mr-4(small v-if="loading")
            span(v-if="!loading") Exportar
    ModalCotizacionNew(quotationType="fullNew")

    // Modal bottom sheet
    BottomSheetModal(
      :showBottomSheet="showBottomSheet"
      :bottomSheetTypes="bottomSheetTypes"
      @setExportType="setExportType"
      @openModalCotizacionNew="openModalCotizacionNew()"
    )
</template>

<script>
import { io } from 'socket.io-client'
import { mapActions } from 'vuex'
import OVActionsIndex from './OVActions/OVActionsIndex.vue'
import GenerarCotizacion from './OVActions/Actions/GenerarCotizacion.vue'
import ModalCotizacionNew from './ModalCotizacionNew.vue'
import { backUrl, webSocketsUrl } from '../../../settings'
import BottomSheetModal from './BottomSheetModal.vue'
import OVSearchInput from './OVSearchInput.vue'

export default {
  name: 'ListOV',
  components: {
    OVActionsIndex,
    GenerarCotizacion,
    ModalCotizacionNew,
    BottomSheetModal,
    OVSearchInput,
  },
  data() {
    return {
      showBottomSheet: {
        show: false,
        type: null,
      },
      bottomSheetTypes: {
        EXPORT: 'export',
        COTIZACION_NEW: 'cotizacion_new',
      },
      item: {},
      showExportRangeModal: false,
      showCotizacionNewModal: false,
      exportType: null,
      loading: false,
      loadingTable: false,
      start_date: null,
      end_date: null,
      paramsSearch: '',
      currentPage: 1,
      pageSize: 21,
      sortBy: null,
      sortDesc: false,
      items: [],
      estados: [],
      tabSelected: null,
      tabNameSelected: null,
      totalRows: 0,
      showEmptyData: false,
      fields: [
        { key: 'id', label: 'ID', class: 'id-column', sortable: true },
        { key: 'created_at', label: 'Fecha de creación', sortable: true },
        { key: 'nombre', label: 'Nombre', sortable: true },
        { key: 'apellido', label: 'Apellido', sortable: true },
        {
          key: 'correo_electronico',
          label: 'Correo Electronico',
          sortable: true,
        },
        { key: 'telefono', label: 'Teléfono', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'rma', label: 'RMA', sortable: true },
        { key: 'monto_total_neto', label: 'Monto Total', sortable: true },
        { key: 'monto_descuento', label: 'Monto c. Dcto.', sortable: true },
        { key: 'ot', label: 'OT', sortable: true },
        { key: 'cotizacion_pdf', label: 'Cotización', sortable: true },
        {
          key: 'acciones',
          label: 'Acciones',
          sortable: true,
          class: 'actions-column',
        },
      ],
    }
  },
  methods: {
    ...mapActions('OVStore', [
      'listOvAll',
      'getEstadosOV',
      'exportOvExcelRange',
    ]),
    getAmountWithDiscount(item) {
      return (
        Math.floor(item.monto_total_neto + item.valor_iva) -
        Math.floor(item.monto_descuento || 0)
      )
    },
    setExportType(type) {
      this.exportType = type
      this.showExportRangeModal = true
    },
    informeUrl(pdf) {
      return `${backUrl}${pdf}`
    },
    sortingChanged(context) {
      this.sortBy = context.sortBy
      this.sortDesc = context.sortDesc
      this.currentPage = 1 // Reiniciar a la primera página cuando se ordena
      this.fetchData(1)
    },
    openModalCotizacionNew() {
      this.$bvModal.show('modal-cotization-completo')
    },
    isAnyModalOpen() {
      let modalsOpen = false
      modalsOpen = document.querySelector('.modal.show') !== null

      // Si no hay modales abiertos, retornar false
      if (!modalsOpen) return false

      // Si hay modales abiertos, validar en 1 segundo
      return new Promise((resolve) => {
        setTimeout(() => {
          modalsOpen = document.querySelector('.modal.show') !== null
          resolve(modalsOpen)
        }, 1000)
      })
    },
    initWebsockets() {
      this.socket = io(webSocketsUrl)
      console.log('INIT WEBSOCKETS', this.socket)
      this.socket.on('connect', () => {
        console.log('WebSocket CONECTADO:', this.socket.id)
      })
      this.socket.onAny((eventName, ...args) => {
        console.log('📡 EVENTO RECIBIDO:', eventName)
        console.log('📦 Datos:', args)
      })
      // Manejar creación de nuevas OV
      this.socket.on('oportunidad_venta:created', async (data) => {
        console.log('NUEVA OPORTUNIDAD DE VENTA CREADA:', data)
        const modalOpen = await this.isAnyModalOpen()
        if (this.paramsSearch || modalOpen) return

        // Ir a obtener la data de la nueva OV para tener datos frescos
        const dataNewOV = await this.listOvAll({
          page: 1,
          estado: null,
          params: data.id,
        })

        if (this.tabNameSelected === dataNewOV.results[0].estado) {
          this.items.unshift(data)
          if (dataNewOV.results && dataNewOV.results.length > 0) {
            this.items.splice(0, 1, dataNewOV.results[0])
          }
          this.totalRows += 1
        }
        const res = await this.getEstadosOV()
        this.estados = res
      })

      // Manejar actualización de OV existente
      this.socket.on('oportunidad_venta:updated', async (updatedData) => {
        console.log('OPORTUNIDAD DE VENTA ACTUALIZADA:', updatedData)
        const modalOpen = await this.isAnyModalOpen()
        if (this.paramsSearch || modalOpen) return
        const ovId = updatedData.id || updatedData

        if (!ovId) {
          console.error(
            'No se pudo obtener el ID de la OV actualizada:',
            updatedData
          )
          return
        }

        // Buscar el índice del item que se actualizó
        const itemIndex = this.items.findIndex((item) => item.id === ovId)

        if (itemIndex !== -1) {
          try {
            const res = await this.listOvAll({
              page: 1,
              estado: null,
              params: ovId,
            })
            if (res.results && res.results.length > 0) {
              const updatedOV = res.results[0]
              // Actualizar solo ese item específico con los datos frescos
              this.items.splice(itemIndex, 1, updatedOV)
            } else {
              console.error(
                'No se encontraron datos actualizados para la OV:',
                ovId
              )
            }
          } catch (error) {
            console.error('Error al obtener los datos de la OV:', error)
          }
        } else {
          console.log('Item con ID', ovId, 'no encontrado en la lista actual')
          console.log(
            'IDs en la lista:',
            this.items.map((item) => item.id)
          )
        }
        const res = await this.getEstadosOV()
        this.estados = res
      })

      // Manejar eliminación de OV
      this.socket.on('oportunidad_venta:deleted', async (deletedOV) => {
        console.log('OPORTUNIDAD DE VENTA ELIMINADA:', deletedOV)
        const modalOpen = await this.isAnyModalOpen()
        if (this.paramsSearch || modalOpen) return

        // Remover el item de la lista
        const itemIndex = this.items.findIndex(
          (item) => item.id === deletedOV.id
        )
        if (itemIndex !== -1) {
          this.items.splice(itemIndex, 1)
          this.totalRows -= 1
        }
        // Cambiar de tab, al primero en caso de que no queden items
        if (this.items.length === 0) {
          this.tabSelected = 0
        }
        const res = await this.getEstadosOV()
        this.estados = res
      })
    },
    async buscar() {
      if (this.paramsSearch && this.paramsSearch.length > 1) {
        this.loadingTable = true
        this.showEmptyData = false
        const ordering = this.sortBy
          ? `${this.sortDesc ? '-' : ''}${this.sortBy}`
          : null
        try {
          const res = await this.listOvAll({
            page: 1,
            estado: null,
            params: this.paramsSearch,
            ordering,
          })
          if (res.count === 0) {
            this.showEmptyData = true
          }
          this.items = res.results
          this.totalRows = res.count
        } catch (error) {
          console.error(error)
        } finally {
          this.loadingTable = false
        }
      } else {
        this.fetchData()
      }
    },

    async getEstados() {
      const res = await this.getEstadosOV()

      try {
        if (res.length > 0) {
          this.estados = res
          // Buscar las OV a partir del primer estado
          this.tabSelected = 0
          this.tabNameSelected = this.estados[0].estado
        }
      } catch (error) {
        console.log('error al obtener los estados', error)
      }
    },

    async fetchData(page = 1) {
      this.items = []
      this.totalRows = 0
      this.loadingTable = true
      this.showEmptyData = false
      const ordering = this.sortBy
        ? `${this.sortDesc ? '-' : ''}${this.sortBy}`
        : null
      try {
        const res = await this.listOvAll({
          page,
          estado: this.tabNameSelected,
          ordering,
        })
        if (res.count === 0) {
          this.showEmptyData = true
        }
        this.items = res.results
        this.totalRows = res.count
      } catch (error) {
        console.log(error)
        this.items = []
        this.totalRows = 0
      } finally {
        this.loadingTable = false
      }
    },
    onTabChange(tab) {
      try {
        this.currentPage = 1
        this.tabNameSelected = this.estados[tab].estado
        if (this.tabNameSelected === 'Todas' && this.paramsSearch) {
          return
        }
        this.fetchData()
      } catch (error) {
        console.log(error)
      }
    },
    handlePageChange(page) {
      this.currentPage = page
      this.fetchData(page)
    },
    async init() {
      await this.getEstados()
      await this.fetchData()
    },
    closeModal() {
      this.start_date = null
      this.end_date = null
      this.showExportRangeModal = false
      this.loading = false
    },
    async exportExcel() {
      const date = {
        fecha_inicio: this.start_date,
        fecha_final: this.end_date,
        type: this.exportType,
      }
      console.log(date)
      this.loading = true
      const res = await this.exportOvExcelRange(date)
      console.log(res, 'response')
      if (
        res.data ===
        'No hay Oportunidades de Venta disponibles en el rango seleccionado'
      ) {
        this.$bvToast.toast(res.data, {
          title: 'Sin datos',
          variant: 'danger',
        })
        this.loading = false
      } else if (res.status === 200) {
        this.$bvToast.toast(
          `Te enviaremos en breve un correo${
            this.user.email ? ` a  ${this.user.email}!` : '!'
          }`,
          {
            title: 'Exportado con éxito!',
            variant: 'success',
          }
        )
        this.closeModal()
      } else {
        this.$bvToast.toast(res.data, {
          title: 'Error',
          variant: 'danger',
        })
        this.closeModal()
      }
    },
  },
  mounted() {
    this.init()
    const { user } = JSON.parse(localStorage.getItem('user'))
    this.user = user
  },
  async created() {
    this.initWebsockets()
  },
  destroyed() {
    if (!this.socket) return
    this.socket.disconnect()
  },
  watch: {
    showExportRangeModal(val) {
      if (!val) {
        this.closeModal()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/style/colors.scss';

::v-deep .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #f4c235;
  color: black;
  font-weight: bold;
  border-radius: 0.5rem;
}

::v-deep .back-arrow {
  color: $samtek-yellow;
  border-radius: 15px;
}

::v-deep .nav-item a {
  color: #525252;
  font-weight: bold;
}

::v-deep .card-header-pills {
  background-color: #f5f6fa;
  border-radius: 0.5rem;
}
::v-deep .nav-item {
  margin: 6px;
}
::v-deep .card-header {
  background-color: #fff;
  overflow-x: auto;
  ul {
    overflow-x: visible;
  }
}

::v-deep .tab-content > .active {
  display: none;
}
::v-deep .b-table thead th {
  background-color: #dddde1;
  color: #525252;
  border: none;
}

::v-deep .b-table tbody td {
  border: none;
  background-color: #fff;
}
::v-deep .b-table tbody tr td:first-child {
  font-weight: bold;
  color: black;
}
::v-deep .id-column {
  width: 60px;
}
::v-deep .actions-column {
  width: 200px;
}
.btn-action {
  background-color: #f4c235;
  color: black;
  border-radius: 0.5rem;
  border: none;
  &:hover {
    background-color: #f4c235;
    color: black;
    box-shadow: none;
  }
}
::v-deep .page-item.active .page-link {
  background-color: #f4c235;
  color: black;
}
::v-deep .page-link {
  color: black;
  border-color: black;
  border: 1px solid black;
  &:hover {
    color: black;
    border: 1px solid black;
    box-shadow: none;
  }
}
::v-deep .form-group label {
  color: #6c757d !important;
  font-weight: bold;
}
::v-deep .dropdown-item {
  font-size: 0.875rem;
}
::v-deep .b-dropdown-text {
  font-size: 0.875rem;
}
::v-deep .dropdown-item:hover {
  background-color: $samtek-yellow;
  border-color: #5b73e8 !important;
}
::v-deep .secondary-btn {
  border-color: $samtek-yellow;
  color: $samtek-black;

  &:hover {
    color: black;
    background-color: rgba(254, 206, 47, 0.1);
    border-color: #e5b823;
    box-shadow: none;
  }
}
::v-deep .tittle-head {
  display: flex;
  justify-content: end;
  align-items: center;
  white-space: nowrap;
}

.badge-rechazada {
  font-size: 12px;
  cursor: pointer;
}
.badge-rechazada-margin {
  margin-top: 16px;
}

.text-subtitle {
  color: #525252;
  font-weight: bold;
  font-size: 16px;
}
.text-no-rechazada {
  color: black;
}
::v-deep tr {
  min-height: 70px;
  height: 70px;
}
</style>
